import React, { JSXElementConstructor, ReactElement } from "react";
import ListViewItem from "@ingka/list-view/ListViewItem";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/aspect-ratio-box/dist/style.css";
import "@ingka/image/dist/style.css";
import "@ingka/switch/dist/style.css";
import "@ingka/forms/dist/style.css";
import "@ingka/list-view/dist/style.css";
import "@ingka/focus/dist/style.css";

type FixaAvatarProps = {
  text: string;
  screenReaderText: string;
};

interface FixaListViewProps {
  id?: string;
  className?: string;
  control?:
    "navigational" | "default" | "checkbox" | "radiobutton" | "link" | "switch";
  onChange?: () => void;
  onClick?: (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => void;
  controlProps?: {
    checked: boolean;
    value: string;
    subtle?: boolean;
  };
  inset?: boolean;
  controlIcon?:
    | "chevronRight"
    | "copy"
    | "chevronRightSmall"
    | "arrowRight"
    | "linkOut"
    | null;
  title?: string | React.ReactElement;
  description?: string | ReactElement<any, string | JSXElementConstructor<any>>;
  showDivider?: boolean;
  size?: "small" | "medium";
  emphasised?: boolean;
  leadingIcon?: (prefix?: string) => React.SVGProps<SVGElement>[];
  image?: string;
  addOn?: React.ReactNode;
  name?: string;
  disabled?: boolean;
  quantityLabel?: React.ReactElement;
  type?: "submit" | "reset" | "button" | undefined;
  href?: string;
  avatarProps?: FixaAvatarProps;
  "data-testid"?: string;
}

export const FixaListViewItem = (props: FixaListViewProps) => {
  return <ListViewItem {...props} />;
};
